import t from"styled-components";import{theme as o}from"../../../../../theme.js";const i=t.div`
  position: relative;
  width: 100%;
  video {
    width: 100%;
    height: auto;
    aspect-ratio: 16/9;
  }
`,e=t.button`
  position: absolute;
  bottom: 80px;
  right: 16px;
  color: ${o.colors.shades[0]};
  border: 1px solid ${o.colors.shades[0]};
  background-color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  padding: ${o.spacing*4}px ${o.spacing*6}px;
  font-size: 12px;
  cursor: pointer;
  display: block;
  height: fit-content;
  @media screen and (max-width: ${o.breakpoints.md}) {
    top: 16px;
    right: 16px;
  }
`,r=t.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${o.spacing*2}px;
  width: 100%;
`;export{r as Container,e as RedirectButton,i as VideoContainer};
